<template>
<div>
  <HomeAltLayout isHome="true" bg_icon='fyiio'>
    <FyiioSvgLogo />
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
              
        <h2 style="color:white;font-size:25pt">Enter confirmation code.</h2>
            
            <div class="alert alert-danger" v-if="error">
              <p v-if="error" class="error">{{ error.message }}</p>
            </div>
        </div>
    </div>
            <form @submit.prevent="passwordResetConfirm">
              <div class="form-group">
                
                <div class="row register-form smallzer">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
                      <div class="input-field" style="height:30px;">
                          <input id="email_inline" type="email" class="fiedler" v-model="username" autocomplete="off" required style="background:white;" >
                          <label for="email_inline" class="adjust-label">Email address</label>
                      </div>
                  </div>
                </div>
                <br>
                <div class="row register-form smallzer ">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
                    <div class="input-field" style="height:30px">
                      <input id="confirmationcode_inline" type="text" class="fiedler form-control" v-model="code" required style="background:white;">
                      <label for="confirmationcode_inline" class="adjust-label">Confirmation code</label>
                    </div>
                  </div>
                </div>
                <br>
                <div class="row register-form ">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
                    
                    <div class="input-field" style="height:30px">
                      <input id="password_inline" class="fiedler form-control" type="password" v-model="pass" autocomplete="off" @input="password_check" required style="background:white;">
                      <div class="right-align inline" v-html="passwordStrengthMessage"></div>
                      <label for="password_inline" class="adjust-label">New password</label>
                    </div>
                  </div>
                </div>    
              </div>
              <div class="row register-form ">
                   <div class=" col s10 m4 offset-m6" :style="$mq === 'md'?'position:relative; left:-10px':''" :class="$mq === 'md'?'left':'center'" >
                    <button class="btn blue"  style="border-radius:20px;text-transform:none">Confirm password reset</button>
                    <br>
                    
                  </div>
                 
              </div>
            </form>
            <div class="row marketing">
             </div>
  </HomeAltLayout>
  
</div>
</template>

<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
import FyiioSvgLogo from '@/components/FyiioSvgLogo'
export default {
  data () {
    return {
      username: this.$route.query.username || '',
      code: '',
      pass: '',
      error: null,
      has_number:    false,
      has_lowercase: false,
      has_uppercase: false,
      has_special:   false,
      has_length: false,
    }
  },
  mounted(){
    $('#bigz').removeClass('blue-bg').addClass('fish-bg');
  },
  methods: {
    passwordResetConfirm () {
      this.$cognitoAuth.confirmPassword(this.username, this.code, this.pass, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {
          this.$router.replace('/login')
        }
      })
    },
    password_check () {
        this.has_number    = /\d/.test(this.pass);
        this.has_lowercase = /[a-z]/.test(this.pass);
        this.has_uppercase = /[A-Z]/.test(this.pass);
        this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.pass);
        this.has_length = this.pass.length > 7;
    },
  },
  components: {
    HomeAltLayout,
    FyiioSvgLogo
  },
  computed: {
    passwordStrength: function() {
      var strength = 0;
      if (this.has_number) strength++;
      if (this.has_lowercase) strength++;
      if (this.has_uppercase) strength++;
      if (this.has_special) strength++;
      if (this.has_length) strength++;
      // return strength;
      return strength;
    },
    passwordMessage: function() {
      var message = "";
      if (this.passwordStrength > 4) {
        message = "Your password is very strong!"
      } else {
        message = "To stengthen your password, please: "
        var messages = [];
        if (!this.has_number) messages.push("include a number")
        if (!this.has_lowercase) messages.push("include a lower case letter")
        if (!this.has_uppercase) messages.push("include an upper case letter")
        if (!this.has_special) messages.push("include a special character")
        if (!this.has_length) messages.push("use more than 8 characters")
        message += messages.join(", ")
      }
      return message;
    },
    passwordStrengthMessage: function() {
      if (this.passwordStrength < 1) {
        return "";
      } else if (this.passwordStrength < 3) {
        return '<div class="passwordStrength weak" title="'+this.passwordMessage+'">weak</div>'
      } else if (this.passwordStrength < 4) {
        return '<div class="passwordStrength medium" title="'+this.passwordMessage+'">medium</div>'
      } else if (this.passwordStrength < 5) {
        return '<div class="passwordStrength strong" title="'+this.passwordMessage+'">strong</div>'
      } else  {
        return '<div class="passwordStrength strong" title="'+this.passwordMessage+'">strong</div>'
      }
    }
  },
}
</script>

<style scoped>
.row {
  margin-bottom: 10px;
}
.error {
  color: red;
}
/*
.mobileLayout {
  background-image: url('./../../assets/galaxy.png');
  background-size: cover;
}*/
</style>



// WEBPACK FOOTER //
// src/containers/authentication/PasswordResetConfirmAlt.vue